import { render, staticRenderFns } from "./CallSecondParticipiant.vue?vue&type=template&id=353048a2&"
import script from "./CallSecondParticipiant.vue?vue&type=script&lang=js&"
export * from "./CallSecondParticipiant.vue?vue&type=script&lang=js&"
import style0 from "./CallSecondParticipiant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports